"use client";

import { useMemo } from "react";

import { FilterValues } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/filter-schema";
import { convertPreferencesToFilters } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/utils";
import { useDiscoverInfo } from "@/hooks/use-discover-info";
import {
  getAdvertisedStateConfigFromAbbreviation,
  IndividualStateConfig,
} from "@/lib/states-config";
import { useAuth } from "@/stores/use-auth";

export interface PreferenceFilters {
  isLoaded: boolean;
  isAuthenticated: boolean;
  preferenceFilters: FilterValues | null;
  hasSupportedLocationPreference: boolean;
  preferenceState: IndividualStateConfig | null;
}

export function usePreferenceFilters(): PreferenceFilters {
  const { isAuthenticated, hasCheckedAuthStatus } = useAuth();
  const { data } = useDiscoverInfo();

  const preferenceFilters = useMemo(() => {
    if (!data?.preference) return null;
    return convertPreferencesToFilters(data.preference);
  }, [data]);

  const preferenceState = getAdvertisedStateConfigFromAbbreviation(
    data?.preference?.geocoded_state ?? null,
  );
  const hasSupportedLocationPreference = preferenceState != null;

  const isLoaded =
    (hasCheckedAuthStatus && !isAuthenticated) || data !== undefined;

  return {
    isLoaded,
    isAuthenticated,
    preferenceFilters,
    hasSupportedLocationPreference,
    preferenceState,
  };
}
